import { render, staticRenderFns } from "./gifts-row.vue?vue&type=template&id=ec462752&scoped=true&"
import script from "./gifts-row.vue?vue&type=script&lang=js&"
export * from "./gifts-row.vue?vue&type=script&lang=js&"
import style0 from "./gifts-row.vue?vue&type=style&index=0&id=ec462752&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec462752",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/inspireyourtribe.salamander.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ec462752')) {
      api.createRecord('ec462752', component.options)
    } else {
      api.reload('ec462752', component.options)
    }
    module.hot.accept("./gifts-row.vue?vue&type=template&id=ec462752&scoped=true&", function () {
      api.rerender('ec462752', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/pageParts/gifts-row.vue"
export default component.exports